/**
 * Social Recovery Module
 * Guardian-based wallet recovery using Shamir Secret Sharing
 */

export { SocialRecoveryManager } from './social';
export * from './shamir';
export * from './types';
